import {
  HOME_GET_LOGIN_TIMES_BEGIN,
  HOME_GET_LOGIN_TIMES_SUCCESS,
  HOME_GET_LOGIN_TIMES_FAILURE,
  HOME_GET_LOGIN_TIMES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getLoginTimes(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_GET_LOGIN_TIMES_BEGIN,
    });

    const { customers } = getState().home;

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let customerIds = '';
      customers.forEach((customer, index) => {
          customerIds += customer.user_id;
          if (customers.length - 1 !== index) {
            customerIds += ',';
          }
      });
        const doRequest = axios.get('https://smartometer-api.appucations.de/all-login-times?users=' + customerIds);
        doRequest.then(
            (res) => {
              dispatch({
                type: HOME_GET_LOGIN_TIMES_SUCCESS,
                data: { res },
              });
              resolve(res);
            },
            // Use rejectHandler as the second argument so that render errors won't be caught.
            (err) => {
              dispatch({
                type: HOME_GET_LOGIN_TIMES_FAILURE,
                data: { error: err },
              });
              reject(err);
            },
        );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetLoginTimesError() {
  return {
    type: HOME_GET_LOGIN_TIMES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_LOGIN_TIMES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLoginTimesPending: true,
        getLoginTimesError: null,
      };

    case HOME_GET_LOGIN_TIMES_SUCCESS:
      // The request is success
      return {
        ...state,
        getLoginTimesPending: false,
        getLoginTimesError: null,
        customers: state.customers.map((customer, i) => {
          const { res: { data: { loginTimes } }} = action.data;
            if(loginTimes[customer.user_id] && loginTimes[customer.user_id][0]) {
              return {...customer, loginTimes: [loginTimes[customer.user_id][0]]}
            } else {
              return state.customers[i];
            }
        }),
      };

    case HOME_GET_LOGIN_TIMES_FAILURE:
      // The request is failed
      return {
        ...state,
        getLoginTimesPending: false,
        getLoginTimesError: action.data.error,
      };

    case HOME_GET_LOGIN_TIMES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getLoginTimesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/getLoginTimes.js